import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'links/vacinados',
		component: Base,
		children: [
			{
				path: '',
				name: 'VacinadosList',
				component: List,
				meta: {
					path: '/links/vacinados',
					pai: 'Links',
					title: 'Admin - Vacinados',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Vacinados',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'VacinadosNovo',
				component: Form,
				meta: {
					path: '/links/vacinados',
					pai: 'Links',
					title: 'Admin - Vacinados - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Vacinados',
						class: '',
						active: false,
						url: '/links/vacinados'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'VacinadosEditar',
				component: Form,
				meta: {
					path: '/links/vacinados',
					pai: 'Links',
					title: 'Admin - Vacinados - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Vacinados',
						class: '',
						active: false,
						url: '/links/vacinados'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]